import axios from "axios";
import {authorizationHeaders} from "./api";

function write(doc, value) {
  if (typeof value === 'string') {
    doc.write(value);
  } else if (typeof value === 'function') {
    const res = value(doc);
    if (typeof res === 'string') {
      doc.write(res);
    }
  }
}

export default function print(title, style, content) {
  const iframe = document.createElement('iframe');
  function closePrint() {
    document.body.removeChild(iframe);
  }
  iframe.onload = function() {
    const win = this.contentWindow;
    const doc = win.document;
    doc.open();
    doc.write('<html><head><title>');
    write(doc, title);
    doc.write('</title><style type="text/css">');
    write(doc, style);
    doc.write('</style></head><body>');
    write(doc, content);
    doc.write('</body></html>');
    doc.close();
    win.onbeforeunload = closePrint;
    win.onafterprint = closePrint;
    win.focus();
    win.print();
  };
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  document.body.appendChild(iframe);
}

export async function printReadModel(title, name, columns, filter = {}, {style, header, footer, dataTransform} = {}) {
  try {
    const res = await axios.get(
      `${process.env.PUBLIC_URL}/api/v1/r/${name}?filter=${encodeURIComponent(JSON.stringify(filter))}&_=${Date.now()}`,
      {headers: authorizationHeaders()});

    let html = (header || '') + '<table width="100%"><thead>';
    for (const column of columns) {
      html += `<th align="left">${column.title}</th>`;
    }
    html += '</thead><tbody>';
    const data = dataTransform ? dataTransform(res.data) : res.data;
    for (const row of data) {
      html += '<tr>';
      for (const column of columns) {
        const value = row[column.dataIndex];
        html += `<td>${(column.print || column.render)(value, row)}</td>`;
      }
      html += '</tr>';
    }
    html += '</tbody></table>' + (footer || '');

    print(title, style || '', html);
  } catch (err) {
    console.error(err);
  }
}



// WEBPACK FOOTER //
// ./src/utils/print.js